import { BsExclamationCircle, BsInfoCircle } from "react-icons/bs";

export const statusColors = {
  DRAFTED: "#8E8E8E",
  PENDING: "#FFCC00",
  REJECTED: "#FF3B30",
  ACCOUNTANT: "#2BB14C",
  SCHEDULED: "#50C40D",
  PAID_IN_FULL: "#007AFF"
};

export const statusStyleTypes = {
  drafted: {
    title: "Drafted",
    icon: <BsExclamationCircle />,
    iconBackgroundColor: "#FC5758",
    backgroundColor: "#FAEEEB",
    borderColor: "#EFD0C7",
    message: "This request is not submitted yet."
  },
  scheduled: {
    title: "Scheduled",
    icon: <BsInfoCircle />,
    iconBackgroundColor: "#3186EA",
    backgroundColor: "#D8E6F9",
    borderColor: "#B4CDEF",
    message: "This payment is scheduled to be paid on the due date."
  }
};
